export default __webpack_public_path__ + "7666dccc068e981266c05f4611aa364c.svg";